import { useHookstate } from '@hookstate/core';
import React, { useEffect } from 'react';
import CrudIndex from '~/components/CrudIndex';
import Layout from '~/components/Layout';
import { useLang } from '~/hooks/useLang';


export default function Index() {
  const { translate } = useLang();
  const name = useHookstate<string | null>(null);
  const areaPlanId = useHookstate<number | null>(null)
  const forceRefresh = useHookstate(false);

  useEffect(() => {
    document.title = translate('Administration - Dispatch System')
  }, [])

  const areaFilters = [
    {
      name: 'area',
      type: 'name',
      variable: name
    },
    {
      name: 'area_plan_id',
      type: 'area_plan_id',
      variable: areaPlanId
    },
  ]
  return (
    <Layout marginLayout={true}>
      <CrudIndex
        model='area'
        title='Area'
        aliasLabel={[
          { column: 'area_plan:name', label: 'Area plan' },
        ]}
        exceptColumns={['polygon_text', 'color', 'polygon']}
        forceOrderColumns={['name', 'acronym', 'area_plan:name']}
        showInViewMore={['name', 'acronym', 'area_plan:name', 'color', 'polygon']}
        canView={true}
        filters={areaFilters}
        clearFilters={() => {
          name.set('')
          areaPlanId.set(null)
          forceRefresh.set(!forceRefresh.get())
        }}
        viewTitle='Area'
        forceRefresh={forceRefresh.get()}
        searchButton={() => forceRefresh.set(!forceRefresh.get())}
      />
    </Layout>
  )
}
